<template>
  <div class="spinner-wrapper">
    <transition name="spinner">
      <div v-if="isLoading" class="uk-text-center spinner-wrapper__block">
        <div class="spinner-wrapper__item" uk-spinner="ratio: 2"></div>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    isLoading: {
      type: [Boolean],
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.spinner-leave-active {
  transition: opacity 0.3s;
}
.spinner-enter,
.spinner-leave-to {
  opacity: 0;
}
.spinner-leave-to {
  transition: opacity 0.3s 0.3s;
}
.spinner-wrapper {
  position: relative;

  &__block {
    width: calc(100% + 20px);
    height: calc(100% + 20px);
    position: absolute;
    top: -10px;
    left: -10px;
    background: #fff;
    z-index: 1;
    padding: 60px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__item {
    color: #e31e24;
  }
}
</style>
